<template>
  <div class="seomain">
    <div class="userinfo_wrap">
      <div class="userinfo_content">
        <div class="left">
          <div class="avatar"><img :src="userinfo.avatar" alt="" /></div>
        </div>
        <div class="middle">
          <div class="name">{{ userinfo.username }}</div>
          <div class="desc">
            <span> {{ userinfo.supervisortypedata || "暂无数据" }} </span>
          </div>
        </div>
        <!-- <div class="right">
          <i class="iconfont icon-jiantouarrow487"></i>
        </div> -->
      </div>
    </div>

    <section class="options_wrap">
      <div v-for="(module, i) in menus" :key="i">
        <el-row :class="'bt_' + desktop[module.module].theme">
          <el-col :span="24" class="title">{{ desktop[module.module].module }}</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-for="(menu, mi) in module.menus" :key="mi">
            <router-link :to="menu.route">
              <div class="icon_wrap">
                <i :class="'iconfont ' + menu.icon + ' ' + desktop[module.module].theme"></i>
              </div>
              <div class="text">{{ menu.title }}</div>
            </router-link>
          </el-col>
        </el-row>
      </div>

    </section>
  </div>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import Cookies from "js-cookie";
import { REDIRECT_URI, SERVER } from "../../../config/global.js";
import desktop from "./conf/desktop.js"
export default {
  data() {
    return {
      queryObj: {},
	  // 桌面配置
	  desktop: desktop,
	  menus: [],
      userinfo: {
        username: "",
        supervisortypedata: "",
        avatat: "",
      }, // 用户信息
    };
  },
  computed: {},
  methods: {
	init() {
		// placeholder init
	},
    handleHashToken() {
      try {
        const hash = window.location.hash || '';
        if (hash.indexOf('sto_user_token=') !== -1) {
          const params = new URLSearchParams(hash.replace(/^#/, ''));
          let token = params.get('sto_user_token');
          if (token) {
            try { token = decodeURIComponent(token); } catch (e) { /* ignore */ }
            // strip surrounding quotes if any
            if (token.length > 1 && token[0] === '"' && token[token.length-1] === '"') {
              token = token.substring(1, token.length-1);
            }
            const cookieDomain = window.location.hostname.endsWith('sys.yksto.com') ? '.sys.yksto.com' : window.location.hostname;
            Cookies.set('sto_user_token', token, { expires: 1, domain: cookieDomain, sameSite: 'None', secure: true });
            window.localStorage.setItem('sto_user_token', token);
            // remove hash without reloading
            history.replaceState(null, '', window.location.pathname + window.location.search);
            // refresh permissions/data
            this.infoFirstPage();
          }
        }
      } catch (e) {
        // ignore
      }
    },
	// 转格式 菜单
	formatMenu(menus) {
		let myMenus = [];
		
		
		// 先显示全部的
		// for (let module in this.desktop) {
		// 	let menutmp = [];
		// 	for (let menu_n in this.desktop[module]['menu']) {
		// 		menutmp.push(this.desktop[module]['menu'][menu_n]);
		// 	}
		// 	myMenus.push({
		// 		module: module,
		// 		menus: menutmp,
		// 	});
		// }
		// this.menus = myMenus.filter((v) => { return v.menus.length > 0 });
		// return;
		
		
		for (let module in this.desktop) {
			myMenus.push({
				module: module,
				menus: [],
			});
		}
		
		for(let module_name in menus) {
			let menu_list = menus[module_name];
			let module_index = myMenus.findIndex((v) => { return module_name == v.module; });
			
			for (let menu_name in menu_list) {
				// 有权 就推入
				if (menu_list[menu_name] && menu_list[menu_name] * 1) {
					if (this.desktop[module_name] && this.desktop[module_name]['menu'][menu_name]) {
						myMenus[module_index].menus.push(this.desktop[module_name]['menu'][menu_name]);
					} else {
						console.log('index/index：err', `后端菜单缺失：${module_name} - ${menu_name}`);
					}
				}
			}
			if (myMenus[module_index] && myMenus[module_index].menus) {
				myMenus[module_index].menus.sort((a, b) => a.weigh - b.weigh);
			}
			
		}
		
		this.menus = myMenus.filter((v) => { return v.menus.length > 0 });
	},
    getUserToken() {
      this.queryObj = this.$getQueryData();
      let code = this.queryObj.code;
      if (code) {
        this.$post(this.$api.stGetUserToken, { code }).then((res) => {
          // 重置url
          history.replaceState({}, "", SERVER);
          // 保存到 Cookie
          const cookieDomain = window.location.hostname.endsWith('sys.yksto.com') ? '.sys.yksto.com' : window.location.hostname;
          Cookies.set("sto_user_token", res.data.token, { expires: 1, domain: cookieDomain, sameSite: "None", secure: true });
          // 保存到 token
          window.localStorage.setItem("sto_user_token", res.data.token);
          let redirectUrl = window.localStorage.getItem("redirect_url");
          console.log(redirectUrl);
          /**
           * 若redirectUrl
           * 为https://st.toasin.cn/ 或 https://st.toasin.cn/index
           * 则不进行跳转
           * */
          let flag =
            redirectUrl == REDIRECT_URI || redirectUrl == REDIRECT_URI + "/" || redirectUrl == REDIRECT_URI + "/index";
          if (redirectUrl && !flag) {
            window.location.href = redirectUrl;
            window.localStorage.removeItem("redirect_url");
            return;
          }
          window.localStorage.removeItem("redirect_url");
          // 获取到token后 发起请求获取权限列表
          this.infoFirstPage();
        });
      }
    },
    async infoFirstPage() {
      let { code } = this.queryObj;
      let token = window.localStorage.getItem("sto_user_token");
      // 如果 localStorage 没有，但 cookie 有（跨子域登录后常见），同步一份，避免被误判未登录
      if (!token) {
        token = Cookies.get("sto_user_token") || "";
        if (token) {
          window.localStorage.setItem("sto_user_token", token);
        }
      }
      if (!token && code) return;
      let result = await this.$post(this.$api.stGetIndexFirstPage);
      this.userinfo = result.data.info;
	  this.formatMenu(result.data.list[0]);
    },
    /**
     * 跳转到培训考试应用
     */
    goToExam() {
      window.location.href = `https://exam.ht-tek.com/`;
    },
  },
  created() {
    this.handleHashToken();
    this.getUserToken();
    this.infoFirstPage();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "晔凯电子" });
    });
  },
  mounted() {},
};
</script>

<style scoped>
.seomain {
  background-color: #f7f4f8;
}

.userinfo_wrap {
  width: 100%;
  height: 148px;
  background-color: #51596e;
}
.userinfo_content {
  display: flex;
  align-items: center;
  padding: 27px 15px;
}
.userinfo_content .left {
  width: 70px;
  height: 70px;
}
.userinfo_content .left .avatar {
  width: 70px;
  height: 70px;
  line-height: 70px;
  font-size: 28px;
  color: #fff;
  background-color: #2a82e4;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.userinfo_content .left .avatar img {
  width: 100%;
  height: 100%;
}
.userinfo_content .middle {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  flex: 1;
  height: 70px;
}
.userinfo_content .middle .name {
  padding-left: 10px;
  font-size: 18px;
  line-height: 27px;
  color: #fff;
}
.userinfo_content .middle .desc {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
  margin-top: 8px;
  padding: 5px 11px;
  height: 26px;
  /* background-color: #00baad; */
  border-radius: 13px;
}
.userinfo_content .middle .desc span {
  background-color: #00baad;
  color: #fff;
  padding: 4px 16px;
  font-size: 12px;
  border-radius: 13px;
  transform: scale(0.8);
}
.userinfo_content .right {
  width: 40px;
  height: 40px;
  text-align: center;
}
.right .icon-jiantouarrow487 {
  line-height: 40px;
  font-size: 28px;
  color: #fff;
}
.options_wrap {
  padding: 18px;
}
.bt_color_y {
  padding-left: 10px;
  border-left: 3px solid #ff8d1a;
}
.bt_color_b {
  padding-left: 10px;
  border-left: 3px solid #2a82e4;
}
.bt_color_g {
  padding-left: 10px;
  border-left: 3px solid #00baad;
}
.bt_color_o {
  padding-left: 10px;
  border-left: 3px solid #b16f39;
}
.bt_color_r {
	padding-left: 10px;
	border-left: 3px solid #ec7f73;
}
.color_y {
  color: #ff8d1a;
}
.color_b {
  color: #2a82e4;
}
.color_o {
  color: #b16f39;
}
.color_g {
  color: #00baad;
}
.color_r {
	color: #ec7f73;
}
.options_wrap .title {
  line-height: 21px;
  color: #505050;
}
.options_content {
  flex-wrap: wrap;
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.options_content .el-col {
  height: 100px;
}
.options_content .el-col .icon_wrap {
  position: relative;
  height: 70%;
  text-align: center;
}
.icon_wrap .iconfont {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%);
  font-size: 30px !important;
  overflow: hidden;
}
.options_content .el-col .text {
  color: #505050;
  text-align: center;
}
</style>
